import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasPermission)?_c('div',[_c(VContainer,{staticClass:"pl-sm-8"},[_c('h1',[_vm._v("Нет прав для просмотра")])])],1):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }